import { Command } from 'commands/Commands';


export class RemovePageRedirect extends Command {
  type: string = 'RemovePageRedirect';
  constructor(public newValue: string[]) {
    super(newValue)
  }
  priority: number = 100;

}
